import React, { FC } from 'react';
import './LabelCellRenderer.scss';

type LabelCellRendererProps = {
    value: string;
    className: string;
    valueFormatted?: string;
};

const LabelCellRenderer: FC<LabelCellRendererProps> = ({
    value,
    className,
    valueFormatted
}: LabelCellRendererProps) => {
    return (
        <div className="label-cell-renderer" title={valueFormatted || value}>
            <span className={`label-cell-renderer__${className}`}>{valueFormatted || value}</span>
        </div>
    );
};
export default LabelCellRenderer;
